<template>
  <footer class="bg-gray-800 text-white text-center p-4 mt-8 shadow-inner">
    <p>&copy; 2026 HR System. All Rights Reserved. Version 1.0.0.7</p>
  </footer>
</template>

<script setup>
// This component does not require any script logic.
</script>

<style scoped>
footer {
  width: 100%;
}
</style>
